import React, { useState } from "react";
import { AutoComplete, Input, message, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  DASHBOARD_ROUTE_CONFIG,
} from "src/layouts/HomePage/SidebarManagement/DashboardRoutes";

interface SmartSearchProps {
  setSelectedMenuItem: (item: string) => void;
}

const pageMap = [
  {
    keyword: "sales",
    label: DASHBOARD_ROUTE_CONFIG[280].dashboardName,
    key: DASHBOARD_ROUTE_CONFIG[280].dashboardName,
    route: DASHBOARD_ROUTE_CONFIG[280].route,
  },
  {
    keyword: "web",
    label: DASHBOARD_ROUTE_CONFIG[293].dashboardName,
    key: DASHBOARD_ROUTE_CONFIG[293].dashboardName,
    route: DASHBOARD_ROUTE_CONFIG[293].route,
  },
  {
    keyword: "organic",
    label: DASHBOARD_ROUTE_CONFIG[301].dashboardName,
    key: DASHBOARD_ROUTE_CONFIG[301].dashboardName,
    route: DASHBOARD_ROUTE_CONFIG[301].route,
  },
  {
    keyword: "ltv",
    label: DASHBOARD_ROUTE_CONFIG[296].dashboardName,
    key: DASHBOARD_ROUTE_CONFIG[296].dashboardName,
    route: DASHBOARD_ROUTE_CONFIG[296].route,
  },
  {
    keyword: "cltv",
    label: DASHBOARD_ROUTE_CONFIG[296].dashboardName,
    key: DASHBOARD_ROUTE_CONFIG[296].dashboardName,
    route: DASHBOARD_ROUTE_CONFIG[296].route,
  },
  {
    keyword: "attribution",
    label: DASHBOARD_ROUTE_CONFIG[303].dashboardName,
    key: DASHBOARD_ROUTE_CONFIG[303].dashboardName,
    route: DASHBOARD_ROUTE_CONFIG[303].route,
  },
  {
    keyword: "customer",
    label: DASHBOARD_ROUTE_CONFIG[303].dashboardName,
    key: DASHBOARD_ROUTE_CONFIG[303].dashboardName,
    route: DASHBOARD_ROUTE_CONFIG[303].route,
  },
  {
    keyword: "overview",
    label: "Email Analytics Overview",
    key: "31",
    route: "/account/engagement/email-analytics-overview",
  },
  {
    keyword: "campaigns",
    label: "Campaign Analytics",
    key: "32",
    route: "/account/engagement/campaign-analytics",
  },
  {
    keyword: "audience",
    label: "Audience Page",
    key: "33",
    route: "/account/engagement/audience",
  },
  {
    keyword: "sources",
    label: "Sources",
    key: "2",
    route: "/account/connect-sources",
  },
  {
    keyword: "user",
    label: "User Management",
    key: "4",
    route: "/account/user-management",
  },
  {
    keyword: "settings",
    label: "Account Settings",
    key: "51",
    route: "/account/my-account/account-settings",
  },
  {
    keyword: "notifications",
    label: "All Notifications",
    key: "52",
    route: "/account/my-account/all-notifications",
  },
  {
    keyword: "preferences",
    label: "Notification Preferences",
    key: "53",
    route: "/account/my-account/notification-preferences",
  },
];

const SmartSearch: React.FC<SmartSearchProps> = ({ setSelectedMenuItem }) => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [options, setOptions] = useState<
    { value: string; label: JSX.Element }[]
  >([]);
  const navigate = useNavigate();// ✅ Context

  const handleSearchChange = (value: string) => {
    setSearchTerm(value);
    const lower = value.toLowerCase();
    const filtered = pageMap.filter(
      item =>
        item.keyword.includes(lower) || item.label.toLowerCase().includes(lower)
    );

    const autoOptions = filtered.map(item => ({
      value: item.key,
      label: (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>{item.label}</span>
          {/* <span style={{ color: "#999", fontSize: "12px" }}>{item.route}</span> */}
        </div>
      ),
    }));

    setOptions(autoOptions);
  };

  const handleSelect = (key: string) => {
    const selected = pageMap.find(item => item.key === key);
    if (selected) {
      setSelectedMenuItem(selected.key);
      setSearchTerm(selected.label);
      navigate(selected.route, {
        state: { dashboardName: selected.label }, // ✅ pass dashboard name
      });
      message.success(`Navigated to: ${selected.label}`);
    } else {
      message.warning("No page found.");
    }
  };

  return (
    <AutoComplete
      options={options}
      style={{ width: "100%", marginTop: "10px" }}
      onSelect={handleSelect}
      onSearch={handleSearchChange}
      value={searchTerm}
      onChange={setSearchTerm}
    >
      <Input.Search
        placeholder={t("sidebar.searchPlaceholder")}
        size="large"
        value={searchTerm}
        onSearch={() => handleSelect(searchTerm.trim())}
        enterButton={
          <Button
            type="primary"
            style={{
              backgroundColor: "rgb(43, 104, 173)",
              borderColor: "rgb(43, 104, 173)",
              height: "40px",
              width: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
            }}
            icon={<SearchOutlined />}
          />
        }
      />
    </AutoComplete>
  );
};

export default SmartSearch;
